import React, { useState, useEffect } from 'react';
import { getVideos } from '../api/videoApi';
import { getImages } from '../api/imageApi';
import { getPdfs } from '../api/pdfApi';
import { getLinks } from '../api/linkApi';
import Footer from './Footer';

function Research() {
  const [videos, setVideos] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        console.log("🔵 Fetching videos, images, and PDFs...");

        const [videoData, imageData, pdfData, linkResponse] = await Promise.all([
          getVideos("Research"), getImages("Research"), getPdfs("Research"), getLinks("Research")
        ]);

        console.log("🟢 API Response - Images:", imageData);
        console.log("🟢 API Response - Videos:", videoData);
        console.log("🟢 API Response - PDFs:", pdfData);
        console.log("🟢 API Response - Links:", linkResponse);

        setVideos(videoData);
        setImages(imageData);
        setPdfs(pdfData);
        setLinks(linkResponse);
      } catch (err) {
        console.error("❌ Error fetching media", err);
        setError("Failed to load media.");
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);

  if (loading) return <p className="text-center text-gray-600">Loading media...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  console.log("📄 Debug PDFs:", pdfs);


  //   return (
  //     <div className="max-w-6xl mx-auto px-6 py-12">
  //       {/* Page Title & Intro */}
  //       <div className="text-center mb-12">
  //         <h1 className="text-5xl font-bold text-purple-800">Research</h1>
  //         <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">
  //           Explore the latest updates from OwenLab, including videos, images, research materials, and important external resources.
  //         </p>
  //       </div>

  //       {/* Media Sections */}
  //       <div className="space-y-12">
  //         {/* Videos */}
  //         <SectionCard title="Videos">
  //           {videos.length > 0 ? (
  //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  //               {videos.map((video) => (
  //                 <MediaCard key={video._id} title={video.title}>
  //                   <video className="w-full rounded-md shadow-lg" controls>
  //                     <source src={video.fileUrl ? `http://localhost:5555${video.fileUrl}` : video.url} type="video/mp4" />
  //                     Your browser does not support the video tag.
  //                   </video>
  //                 </MediaCard>
  //               ))}
  //             </div>
  //           ) : (
  //             <NoContent text="No videos found." />
  //           )}
  //         </SectionCard>

  //         {/* Images */}
  //         <SectionCard title="Images">
  //           {images.length > 0 ? (
  //             <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
  //               {images.map((image) => (
  //                 <MediaCard key={image._id} title={image.title}>
  //                   {/* <img
  //                     className="w-full h-auto rounded-md shadow-md object-cover transform transition-transform duration-300 hover:scale-105"
  //                     // src={image.imageUrl ? image.imageUrl.replace("_640", "_1280") : `http://localhost:5555${image.fileUrl}`}
  //                     src={image.fileUrl ? `http://localhost:5555${image.fileUrl}` : image.url}
  //                     alt={image.title || "Uploaded Image"}
  //                     onError={(e) => e.target.src = "/default-placeholder.png"}
  //                   /> */}
  //                   <img
  //                     className="w-full h-auto rounded-md mt-2 object-cover"
  //                     src={image.imageUrl} // ✅ This always holds the correct URL
  //                     alt={image.title || "Uploaded Image"}
  //                     onError={(e) => (e.target.src = "/default-placeholder.png")} // ✅ Fallback if image fails to load
  //                   />


  //                 </MediaCard>
  //               ))}
  //             </div>
  //           ) : (
  //             <NoContent text="No images found." />
  //           )}
  //         </SectionCard>

  //         {/* PDFs */}
  //         <SectionCard title="PDFs">
  //           {pdfs.length > 0 ? (
  //             <ul className="space-y-2">
  //               {pdfs.map((pdf) => (
  //                 // <li key={pdf._id}>
  //                 //   <button
  //                 //     // href={pdf.fileUrl ? `http://localhost:5555${pdf.fileUrl}` : pdf.url}
  //                 //     href={pdf.pdfUrl ? `http://localhost:5555${pdf.pdfUrl}` : pdf.url}
  //                 //     target="_blank"
  //                 //     rel="noopener noreferrer"
  //                 //     className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //                 //   >
  //                 //     {pdf.title || "Untitled PDF"}
  //                 //   </button>
  //                 // </li>
  //                 <li key={pdf._id}>
  //                   {/* <button
  //                     onClick={() => {
  //                       console.log("📂 Opening PDF:", pdf.pdfUrl); // ✅ Debugging output
  //                       if (pdf.pdfUrl) {
  //                         window.open(pdf.pdfUrl, "_blank", "noopener,noreferrer");
  //                       } else {
  //                         alert("PDF link is missing.");
  //                       }
  //                     }}
  //                     className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //                   >
  //                     {pdf.title || "Untitled PDF"}
  //                   </button> */}
  //                   {/* <button
  //                     onClick={() => {
  //                       const pdfLink = pdf.fileUrl || pdf.url;  // 🔥 FIX HERE: Ensure correct URL field

  //                       if (!pdfLink) {
  //                         alert("PDF link is missing.");
  //                         return;
  //                       }

  //                       if (!pdfLink.startsWith("http")) {
  //                         pdfLink = `http://localhost:5555${pdfLink}`;
  //                       }

  //                       console.log("📂 Opening PDF URL:", pdfLink);
  //                       window.open(pdfLink, "_blank", "noopener,noreferrer");
  //                     }}
  //                     className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //                   >
  //                     {pdf.title || "Untitled PDF"}
  //                   </button> */}

  // {/* <button
  //             onClick={() => {
  //               console.log("📄 Full PDF Item:", pdf); // Debugging
  //               const pdfLink = pdf.fileUrl || pdf.url; // ✅ Fix: Use correct URL field
  //               console.log("📂 Opening PDF URL:", pdfLink); // Debugging

  //               if (pdfLink) {
  //                 window.open(pdfLink, "_blank", "noopener,noreferrer");
  //               } else {
  //                 alert("PDF link is missing.");
  //                 console.error("❌ No valid PDF URL found!", pdf);
  //               }
  //             }}
  //             className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //           >
  //             {pdf.title || "Untitled PDF"}
  //           </button> */}

  // <button
  //             onClick={() => {
  //               console.log("Full PDF Item:", pdf);
  //               console.log("Checking fileUrl:", pdf.fileUrl);
  //               console.log("Checking url:", pdf.url);
  //               console.log("📄 Full PDF Item:", pdf); // Debugging
  //               let pdfLink = pdf.pdfUrl || pdf.fileUrl || pdf.url; // ✅ Use correct URL field

  //               if (!pdfLink) {
  //                 alert("PDF link is missing.");
  //                 console.error("❌ No valid PDF URL found!", pdf);
  //                 return;
  //               }

  //               console.log("Initial PDF URL before processing:", pdfLink);

  //               // ✅ Fix for uploaded PDFs (ensure proper URL format)
  //               if (!pdfLink.startsWith("http")) {
  //                 // pdfLink = `http://localhost:5555${pdfLink}`;
  //                 pdfLink = `http://localhost:5555${pdfLink.replace(/^\/+/, '')}`;
  //               }

  //               console.log("📂 Final PDF URL:", pdfLink);
  //               window.open(pdfLink, "_blank", "noopener,noreferrer");
  //             }}
  //             className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //           >
  //             {pdf.title || "Untitled PDF"}
  //           </button>

  //                 </li>


  //               ))}
  //             </ul>
  //           ) : (
  //             <NoContent text="No PDFs found." />
  //           )}
  //         </SectionCard>

  //         {/* External Links */}
  //         <SectionCard title="External Links">
  //           {links.length > 0 ? (
  //             <ul className="space-y-2">
  //               {links.map((link) => (
  //                 <li key={link._id}>
  //                   <a
  //                     href={link.url}
  //                     target="_blank"
  //                     rel="noopener noreferrer"
  //                     className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
  //                   >
  //                     {link.title || "Untitled Link"}
  //                   </a>
  //                 </li>
  //               ))}
  //             </ul>
  //           ) : (
  //             <NoContent text="No external links found." />
  //           )}
  //         </SectionCard>
  //       </div>
  //     </div>
  //   );
  // }

  // /* Section Wrapper */
  // const SectionCard = ({ title, children }) => (
  //   <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-6">
  //     <h2 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h2>
  //     {children}
  //   </section>
  // );

  // /* Card for Media Items */
  // const MediaCard = ({ title, children }) => (
  //   <div className="bg-gray-50 rounded-lg p-4 border border-gray-300 shadow-md">
  //     <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
  //     {children}
  //   </div>
  // );

  // /* Placeholder for Empty Sections */
  // const NoContent = ({ text }) => <p className="text-gray-500">{text}</p>;

  return (
    <div className="w-full font-sans">
      {/* Full-width Image Header */}
      <div className="relative w-full m-h-screen mt-0">
        <img
          src="/Hero-Research.jpeg"
          // className="w-full h-[70vh] object-cover"
          // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
          className="w-full h-auto object-cover object-center"
          alt="Our Research"
        />
        <div className="absolute inset-x-0 bottom-0 sm:bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
          <div className="bg-black bg-opacity-50 p-2 sm:p-6 rounded-lg inline-block">
            <h1 className="text-xl sm:text-5xl font-bold drop-shadow-lg">Our Research</h1>
          </div>
        </div>
      </div>

      {/* Content Container: same gutters as Home */}
      <div className="max-w-6xl mx-auto my-12 px-6 space-y-1">

        <div className="px-6">
          <h2 className="text-3xl md:text-4xl text-primary font-bold mb-1">Overview</h2>
        </div>

        {/* Research Blurb + Image */}
        <section className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
          <div className="sm:text-sm md:text-md lg:text-lg p-6 text-gray-800 text-lg leading-relaxed">
            A fundamental question that drives much of the research in the Owen Lab is “What is it like to……?"
            What is it like to be entirely conscious, yet unable to move or speak following a serious brain injury?
            What is it like to experience an engaging movie while asleep, or under the influence of a powerful anaesthetic?
            What is it like to live every day as a patient with Alzheimer’s disease?
            What is it like to view the world through the lens of a strong psychedelic drug, like psilocybin?

            We answer these questions using cutting-edge neuroscientific tools, including functional magnetic
            resonance imaging (fMRI), electroencephalography (EEG), functional near-infrared spectroscopy (fNIRS)
            and the Creyos online cognitive assessment platform.
          </div>
          {/* <div className="md:w-1/2 flex justify-center"> */}
          <div className='rounded-lg shadow-2xl shadow-black/100'>
            <img
              src="/OwenLab-cap.jpeg"
              alt="Owen Lab research"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>
          {/* </div> */}
        </section>


        <div className="h-8" />
        <TwoColumnSection
          title="Creyos"
          description="Creyos (formerly Cambridge Brain Sciences) is our web-based cognitive assessment platform for testing memory, attention, reasoning, problem-solving, decision-making, and planning. It has evolved through more than 400 peer-reviewed publications over the last 25 years and to date, approximately 20 million individual assessments have been completed on the site. Creyos is currently being used by several hundred research groups around the world, as well as by more than 10,000 healthcare providers and practices. Creyos was spun off through the Canada Excellence Research Chairs (CERC) program and currently employs around 100 people through their offices in Toronto and London."
          image="/Creyos.jpg"
          link={{ url: "https://www.habstudy.com", text: "Visit Creyos" }}
          reversed
          shadowColor='shadow-black/80'
        />

        <div className="h-8" />
        <TwoColumnSection
          title="EEJeep"
          description="Our EEJeep is a fully equipped mobile lab designed for on-site brain imaging, allowing us to study and assess patients who cannot travel to our research facilities. It was funded by a grant from the Canadian Foundation for Innovation (CFI) and has been driven from coast to coast in the name of science. The EEJeep has featured in many science documentaries, including a BBC Panorama special. "
          image="/eejeep-side.jpg"
          shadowColor='shadow-black/100'
        />


      </div>
      <Footer isFullFooter={false} />
    </div>
  );
}

/* Two Column Section */
// const TwoColumnSection = ({ title, description, image, link, reversed }) => (
//   // <section className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10 bg-white p-8 rounded-xl shadow-lg border border-gray-200`}>
//   <section className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10`}>
//     <div className="w-full md:w-1/2 flex justify-center">
//       {/* <img src={image} alt={title} className="rounded-lg shadow-lg w-full h-auto max-h-80 object-cover" /> */
//       <img src={image} alt={title} className="rounded-lg shadow-lg w-full h-auto object-contain" />}
//     </div>
//     <div className="w-full md:w-1/2 text-left">
//       <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2>
//       <p className="text-lg text-gray-700 mb-4 leading-relaxed">{description}</p>
//       {link && (
//         <a href={link.url} target="_blank" rel="noopener noreferrer" className="inline-block bg-accent text-white px-5 py-3 rounded-md shadow-md hover:bg-opacity-90 transition">
//           {link.text}
//         </a>
//       )}
//     </div>
//   </section>
// );

const TwoColumnSection = ({ title, description, image, link, reversed, shadowColor = "shadow-black/50" }) => (
  // <section className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10 bg-white p-8 rounded-xl shadow-lg border border-gray-200`}>
  // <section className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10`}>

  //   <div className="w-full md:w-1/2 text-left">
  //     {/* <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2> */}
  //     <h2 className="font-bold mb-4 text-[clamp(1.25rem,3.5vw,2,25rem)]">{title}</h2>
  //     <p className="text-lg text-gray-700 mb-4 leading-relaxed">{description}</p>
  //     {link && (
  //       <a href={link.url} target="_blank" rel="noopener noreferrer" className="inline-block bg-accent text-white px-5 py-3 rounded-md shadow-md hover:bg-opacity-90 transition">
  //         {link.text}
  //       </a>
  //     )}
  //   </div>

  //   <div className="w-full md:w-1/2 flex justify-center">
  //     {/* <img src={image} alt={title} className="rounded-lg shadow-lg w-full h-auto max-h-80 object-cover" /> */
  //     // <img src={image} alt={title} className="rounded-lg shadow-lg w-full h-auto object-contain" />}
  //     // <img src={image} alt={title} className="rounded-lg shadow-lg w-full h-auto object-contain" />}
  //     <img src={image} alt={title} className="h-full w-auto object-contain rounded-lg shadow-lg" />}




  //   </div>
  // </section>

  //   <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
  //   {/* TEXT SIDE */}
  //   <div className="px-6">
  //     <h2 className="text-4xl font-bold mb-4">{title}</h2>
  //     <p className="text-lg leading-relaxed mb-4">{description}</p>
  //     {link && (
  //       <a
  //         href={link.url}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="inline-block bg-accent text-white px-5 py-3 rounded-md shadow-md hover:bg-opacity-90 transition"
  //       >
  //         {link.text}
  //       </a>
  //     )}
  //   </div>

  //   {/* IMAGE SIDE */}
  //   <div className="px-6">
  //     <img
  //       src={image}
  //       alt={title}
  //       className="w-full h-auto rounded-lg shadow-lg object-cover"
  //     />
  //   </div>
  // </section>

  <section
    className={`grid grid-cols-1 md:grid-cols-2 gap-12
      ${reversed ? "md:grid-flow-col-dense" : ""}`}
  >
    {/* Text side */}
    {/* <div className="px-6 order-2 md:order-1 flex flex-col justify-center"> */}
    <div
      className={`
      px-6 
      order-1               /* mobile: text first */
      ${reversed
          ? "md:order-2"      /* md+: if reversed, text becomes second */
          : "md:order-1"      /* md+: otherwise, text stays first */
        } 
      flex flex-col justify-center
    `}
    >
      <h2 className="text-2xl md:text-3xl lg:text-4xl text-primary font-bold mb-4">
        {title}
      </h2>
      <p className="text-base sm:text-sm md:text-md lg:text-lg text-gray-700 leading-relaxed mb-6">
        {description}
      </p>
      {link && (
        <a
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          // className="inline-block bg-accent text-white px-5 py-3 rounded-md shadow-md hover:bg-opacity-90 transition"
          className="self-start bg-accent text-white px-5 py-3 rounded-md shadow-md hover:bg-opacity-90 transition"
        >
          {link.text}
        </a>
      )}
    </div>

    {/* Image side */}
    {/* <div className="px-6 order-1 md:order-2 flex items-center"> */}
    <div
      className={`
      px-6 
      order-2               /* mobile: image second */
      ${reversed
          ? "md:order-1"      /* md+: if reversed, image moves first */
          : "md:order-2"      /* md+: otherwise, image stays second */
        }
      flex items-center
    `}
    >
      <img
        src={image}
        alt={title}
        // className="w-full h-auto rounded-lg shadow-2xl shadow-black/80 object-cover"
        className={`w-full h-auto rounded-lg shadow-2xl ${shadowColor} object-cover`}
      />
    </div>
  </section>


);



export default Research;



